(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-hb-gallery]:not([data-hb-bound])').forEach(gallery => {
      gallery.dataset.hbBound = 'true';
      const slides = [...gallery.querySelectorAll('[data-hb-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-hb-thumb]')];
      if (!slides.length) return;
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        const counter = gallery.querySelector('[data-hb-counter]');
        if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      gallery.querySelector('[data-hb-prev]')?.addEventListener('click', () => show(current - 1));
      gallery.querySelector('[data-hb-next]')?.addEventListener('click', () => show(current + 1));
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[current]?.focus({ preventScroll: true });
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); show(event.key === 'Home' ? 0 : slides.length - 1);
          thumbs[current]?.focus({ preventScroll: true });
        }
      });
      let touchX = null;
      const stage = gallery.querySelector('.nlm-hb__gallery-stage');
      stage?.addEventListener('touchstart', event => { touchX = event.changedTouches[0].clientX; }, { passive: true });
      stage?.addEventListener('touchend', event => {
        if (touchX === null) return;
        const delta = event.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 50) show(current + (delta < 0 ? 1 : -1));
        touchX = null;
      }, { passive: true });
    });
    scope.querySelectorAll('.nlm-hb__video:not([data-hb-bound])').forEach(wrapper => {
      wrapper.dataset.hbBound = 'true';
      const video = wrapper.querySelector('video');
      const play = wrapper.querySelector('[data-hb-play]');
      if (!video) return;
      video.muted = true;
      // Autoplay is silent and looping; the button only appears when the browser refuses to start it.
      const attempt = () => {
        const started = video.play();
        if (started && typeof started.catch === 'function') {
          started.catch(() => { if (play) play.hidden = false; });
        }
      };
      play?.addEventListener('click', () => { play.hidden = true; attempt(); });
      video.addEventListener('playing', () => { wrapper.dataset.playing = 'true'; if (play) play.hidden = true; });
      video.addEventListener('pause', () => { wrapper.dataset.playing = 'false'; });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) { attempt(); } else { video.pause(); } });
        }, { threshold: 0.2 });
        observer.observe(wrapper);
      } else {
        attempt();
      }
    });
    scope.querySelectorAll('[data-hb-product]:not([data-hb-bound])').forEach(root => {
      root.dataset.hbBound = 'true';
      const form = root.querySelector('[data-hb-form]');
      const tiers = [...root.querySelectorAll('[data-hb-tier]')];
      const buy = root.querySelector('[data-hb-buy]');
      const sticky = root.querySelector('[data-hb-sticky]');
      const stickyBuy = root.querySelector('[data-hb-sticky-buy]');
      const stickyPrice = root.querySelector('[data-hb-sticky-price]');
      const status = root.querySelector('[data-hb-status]');
      const variantSelect = root.querySelector('[data-hb-variant]');
      const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: root.dataset.currency || 'AUD' });
      const referenceMoney = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
      const update = () => {
        const tier = tiers.find(item => item.checked);
        if (!tier) return;
        if (stickyPrice && (root.dataset.commerceReady === 'true' || tier.dataset.reference === 'true')) {
          stickyPrice.textContent = tier.dataset.reference === 'true' ? 'A' + referenceMoney.format(Number(tier.dataset.total) / 100) : money.format(Number(tier.dataset.total) / 100);
        }
        const available = !variantSelect || variantSelect.selectedOptions[0]?.dataset.available === 'true';
        if (buy) buy.disabled = root.dataset.commerceReady !== 'true' || !available;
        if (stickyBuy) stickyBuy.disabled = !buy || buy.disabled;
        root.dispatchEvent(new CustomEvent('nlm-hb:quantity-change', { bubbles: true, detail: { quantity: Number(tier.value) } }));
      };
      tiers.forEach(tier => tier.addEventListener('change', update));
      variantSelect?.addEventListener('change', () => {
        const price = Number(variantSelect.selectedOptions[0]?.dataset.price || 0);
        tiers.forEach(tier => {
          if (tier.dataset.reference === 'true') return;
          tier.dataset.total = String(price * Number(tier.value));
          tier.dataset.discountVerified = 'false';
          const label = tier.closest('label');
          const strong = label?.querySelector('.nlm-hb__offer-price strong');
          const small = label?.querySelector('.nlm-hb__offer-price>small');
          if (strong) { const each = strong.querySelector('small'); strong.firstChild.textContent = money.format(price / 100); if (each && !each.isConnected) strong.append(each); }
          if (small) { const suffix = small.textContent.trim().split(' ').at(-1); small.textContent = `${money.format(price * Number(tier.value) / 100)} ${suffix}`; }
        });
        update();
      });
      update();
      const watched = buy || root.querySelector('.nlm-hb__form button');
      if (sticky && watched) {
        const lifecycle = new AbortController();
        let frame = 0;
        let observer;
        const cleanup = () => {
          lifecycle.abort();
          observer?.disconnect();
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
        };
        const syncSticky = () => {
          frame = 0;
          if (!root.isConnected) { cleanup(); return; }
          sticky.hidden = watched.getBoundingClientRect().bottom > 0;
        };
        const scheduleSticky = () => {
          if (!frame) frame = requestAnimationFrame(syncSticky);
        };
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(scheduleSticky, { threshold: 0 });
          observer.observe(watched);
        }
        window.addEventListener('scroll', scheduleSticky, { passive: true, signal: lifecycle.signal });
        window.addEventListener('resize', scheduleSticky, { passive: true, signal: lifecycle.signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) cleanup();
        }, { signal: lifecycle.signal });
        scheduleSticky();
      }
      stickyBuy?.addEventListener('click', () => { if (buy && !buy.disabled) form?.requestSubmit(buy); });
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        if (!buy || buy.disabled || root.dataset.commerceReady !== 'true') return;
        buy.disabled = true;
        if (stickyBuy) stickyBuy.disabled = true;
        if (status) status.textContent = root.dataset.adding;
        try {
          const currentCart = await fetch(root.dataset.cartJson, { headers: { Accept: 'application/json' } });
          if (!currentCart.ok) throw new Error('cart');
          const response = await fetch(`${root.dataset.cartAdd}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('cart');
          await response.json();
          if (status) {
            status.textContent = `${root.dataset.added} `;
            const link = document.createElement('a'); link.href = root.dataset.cartUrl; link.textContent = root.dataset.viewCart; status.append(link);
          }
          root.dispatchEvent(new CustomEvent('nlm-hb:cart-added', { bubbles: true }));
        } catch {
          if (status) status.textContent = root.dataset.error;
        } finally { update(); }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
